import React, { useEffect, useState } from "react";
import { GetBlog } from "../../api/blogApis/blogApi";
import { useLocation, useNavigate } from "react-router-dom";
import "./ViewAdminBlog.css";
import _default from "dompurify";
import Loader from "../../app/constants/Loader/loader";

export default function ViewAdminBlog() {
  const navigate = useNavigate();
  const location = useLocation();
  const blogId = location.state?.blogId;
  // const returnPath = location.state?.returnPath || "/";

  const [finalResponse, setFinalResponse] = useState([]);
  const [success, setSuccess] = useState(true);

  useEffect(() => {
    if (blogId) {
      fetchBlogById(blogId);
    }
  }, [blogId]);

  const fetchBlogById = async (id) => {
    try {
      const response = await GetBlog({ blogId: id });

      if (response.result === 1) {
        setFinalResponse(response.result_value);
      } else {
        setSuccess(false);
      }
    } catch (error) {
      console.error("API Error:", error);
      setSuccess(false);
    }
  };

  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <>
      <div className="role-box">
        <ul className="breadcumb">
          <li className="active" onClick={handleBack}>
            <i className="bi bi-file-earmark-richtext"></i>
            Blog
          </li>

          <li className="dash-arrow">/</li>

          <li>
            <span>View Blog</span>
          </li>
        </ul>
      </div>

      <div
        className="main_widget p-20"
        style={{
          height: "auto",
          minHeight: "fit-content",
        }}
      >
        <div className="main_widget_body blog_preview_widget">
          {success ? (
            finalResponse?.length === 0 ? (
              <p>
                <Loader />
              </p>
            ) : (
              <div className="blog_post_main_headin_txt">
                <div className="blog_heading">
                  <h1>{finalResponse?.blog_title}</h1>
                </div>
                <p className="post_des">{finalResponse.blog_description}</p>
                <div className="blog_post_preview_cover_img">
                  <img src={finalResponse?.blog_coverImage} alt="Images" />
                </div>

                <div className="blog_description">
                  <div className="blog_post_publish_details">
                    <span>{finalResponse?.author_name}</span>
                    {finalResponse?.created_at && (
                      <span>
                        Date :{" "}
                        {new Date(
                          finalResponse?.created_at,
                        ).toLocaleDateString() || "Loading..."}
                      </span>
                    )}
                  </div>
                </div>

                <div
                  className="blog_post_content"
                  dangerouslySetInnerHTML={{
                    __html: _default.sanitize(finalResponse.blog_content),
                  }}
                ></div>
              </div>
            )
          ) : (
            <p>Something went wrong.</p>
          )}
        </div>
      </div>
    </>
  );
}
